<template>
  <div class="newsletter">
    <div>
      <div>{{ insertString("Global", "Footer", "LoyaltyText") }}</div>
      <ButtonComponent
        class="m-t-12"
        :theme="'main'"
        :overrideThemeColor="Globals.colors.gray"
        :ghost="true"
        :block="false"
        :small="true"
        tabindex="0"
        :text="insertString('Global', 'SignUp') || 'Sign up'"
        :href="signUpLink"
      />
    </div>

    <label for="subscribeNewsletter" class="m-t-24 m-b-0 -small-caps -strong"><strong>{{ insertString("Global", "Subscribe") }}</strong></label>
    <div class="newsletter-agree-row" v-if="!submitted">
      <ul
        role="listbox"
        aria-label="Agree to marketing and analyst"
        aria-multiselectable="true"
      >
        <li role="option">
          <label for="agreeToMarketing" class="-clickable">
            <input
              id="agreeToMarketing"
              name="agreeToMarketing"
              required="required"
              :data-value-missing="insertString('Global', 'FieldRequired')"
              type="checkbox"
              value="true"
            />
            <span>
              <strong>{{ insertString("Global", "Footer", "NewsletterAgreeToMarketing") }}</strong>
            </span>
          </label>
        </li>
        <li role="option">
          <label for="agreeToAnalyst" class="-clickable">
            <input
              id="agreeToAnalyst"
              type="checkbox"
              name="agreeToAnalyst"
              value="true"
            />
            <span>
              <strong>{{ insertString("Global", "Footer", "NewsletterAgreeToAnalyst") }}</strong>
            </span>
          </label>
        </li>
      </ul>
    </div>
    <Signup
      id="subscribeNewsletter"
      class="m-t-9"
      v-model="email"
      :inputName="'email'"
      :confirmation="insertString('Global', 'SubscribeSuccess')"
      :small="true"
      :buttonStyle="buttonStyle"
      :includeForm="false"
      :disabled="!isFocus"
      @submit="submit"
      @focus="isFocus = true"
    />
  </div>
</template>
<script>
import Api from '@/Scripts/api/api';
import Signup from '@/Scripts/components/form/Signup/Signup.vue';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';

import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
export default {
  mixins: [siteInfo],
  components: {
    Signup,
    ButtonComponent
  },
  data: function () {
    return {
      viewAgree: false,
      success: false,
      email: '',
      isFocus: false,
      submitted: false
    };
  },
  computed: {
    buttonStyle () {
      return {
        text: !this.isFocus ? this.Globals.colors.blackLight : '',
        background: !this.isFocus ? '#A3A3A3' : this.Globals.colors.blueDark
      };
    },
    signUpLink () {
      return this.getLink('loyaltyPage') + `?&redirectUrl=${location.pathname}${location.search}&source=footer`;
    }

  },
  methods: {
    toggleInput: function (view) {
      this.viewAgree = view;
    },
    submit () {
      this.submitted = true;
      const form = document.getElementById('subscribeNewsletter');

      form.reportValidity();

      if (form.checkValidity()) {
        const data = new FormData(form);

        Api.postNoLanguage(form.action, null, data).then(response => {
          if (response.status === 200) {
            this.success = true;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";
@import "@/scss/components/components.checkbox.scss";

.newsletter {
  input {
    color: $gray-light !important;
    border-color: $gray-light !important;
    background-color: transparent;
    @include media-breakpoint-down(sm) {
      font-size: 16px !important;
      &::placeholder {
        font-size: 13px !important;
      }
    }
  }
  &-form-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @include media-breakpoint-up(lg) {
      flex-wrap: nowrap;
    }
  }

  &-agree-row {
    margin-top: 18px;
  }

  .form-control-feedback {
    display: none;
  }

  input[type="submit"] {
    height: 24px;
    margin-top: 9px;
    color: #bebebe;
    background-color: transparent;
    border: 1px solid #bebebe;
    border-radius: 3px;

    @include media-breakpoint-up(lg) {
      margin-top: 0;
    }
  }

  input[type="email"] {
    width: 100%;
    padding: 6px 0;
    margin-right: 18px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 300;
    color: #bebebe;
    background-color: transparent;
    border: 0;
    border-bottom: 2px solid #bebebe;
    outline: 0;

    @include media-breakpoint-up(lg) {
      width: 50%;
    }

    &::placeholder {
      color: #bebebe;
      opacity: 0.45;
    }
  }

  input[type="checkbox"] {
    + span {
      font-weight: 300;

      &::after {
        border-color: $white !important;
      }
    }
  }
}
</style>
